"use client"

import { useEffect, useRef } from "react"

export function ReaderLock({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const stop = (e: Event) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const onKey = (e: KeyboardEvent) => {
      const meta = e.metaKey || e.ctrlKey
      if (!meta) return
      const k = e.key.toLowerCase()
      if (k === "c" || k === "x" || k === "a" || k === "s" || k === "p") {
        e.preventDefault()
        e.stopPropagation()
      }
    }

    el.addEventListener("copy", stop)
    el.addEventListener("cut", stop)
    el.addEventListener("contextmenu", stop)
    el.addEventListener("selectstart", stop)
    el.addEventListener("dragstart", stop)
    document.addEventListener("keydown", onKey)

    return () => {
      el.removeEventListener("copy", stop)
      el.removeEventListener("cut", stop)
      el.removeEventListener("contextmenu", stop)
      el.removeEventListener("selectstart", stop)
      el.removeEventListener("dragstart", stop)
      document.removeEventListener("keydown", onKey)
    }
  }, [])

  return (
    <div
      ref={ref}
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        WebkitTouchCallout: "none",
      } as React.CSSProperties}
    >
      {children}
    </div>
  )
}
